import { gql } from "@apollo/client";

export const AI_ADDONS_QUERY = gql`
  query GetAIAddons {
  aiAddons {
    id
    name
    description
    pricingType
    amount
    currency
    interval
    intervalCount
    creditPoolSize
     stripeProductId
        stripePriceId
        eligiblePlanIds
    active
    type
    credits
     createdAt
        updatedAt
        deletedAt
  }
}
`;

// Work Orders  Query
